const __request = require(`../__request/__request_contentType_json`);

// 国际机票改签
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/flight/international/buyer/white/order/change',
    data:data
  }

  return __request(pParameter)
}

